module.exports = __webpack_public_path__ + "static/media/more-onoake.fa2c1a70.png";